import React from "react";
import { Link, useLocation } from "react-router-dom";
import Slider from "components/UI/Slider";
import styles from "./RestaurantSlider.module.css";
import RestaurantSliderSkeleton from "./skeleton/RestaurantSliderSkeleton";
import phoneBlack from "assets/images/icon-phone-black.svg";
import placeholder515x575 from "assets/placeholder/515x575.png";
import playClickSpecial from "utils/playClickSpecial";

function RestaurantHomeSlider(props) {
  const { loading, resSlider, resTitle } = props;
  const location = useLocation();
  const pathname = location.pathname;

  if (!resSlider || loading) {
    return <RestaurantSliderSkeleton />;
  }

  return (
    <div className={styles.rest_should_try}>
      <h2 className={styles.rest_should_try_title}>{resTitle}</h2>
      <div className={styles.wrapp_item_content}>
        <div className="customSplidePagination">
          <Slider>
            {resSlider.map((item, index) => (
              <div key={index}>
                <h4 className={styles.title}>{item.title}</h4>
                <div className={styles.phone_number}>
                  {item.phone && (
                    <>
                      <img
                        src={phoneBlack}
                        className={styles.phone_image}
                        alt={item.title}
                      />
                      {item.phone}
                    </>
                  )}
                </div>
                <div className="item_slider" key={index}>
                  {item.id && item.code ? (
                    <Link
                      to={{
                        pathname: `${pathname}/${item.id}`,
                        search: `?code=${item.code}`,
                      }}
                      onClick={playClickSpecial}
                    >
                      <img
                        src={item.photo || placeholder515x575}
                        style={{ height: 285 }}
                        alt="restaurant image"
                      />
                    </Link>
                  ) : (
                    <img
                      src={item.photo || placeholder515x575}
                      style={{ height: 285 }}
                      alt="restaurant image"
                    />
                  )}
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}
export default RestaurantHomeSlider;
